/* VIDA - Sistema de ingredientes: clic en un ingrediente > hoja de detalle (nombre, cantidad, funcion, descripcion).
   Los datos salen de los atributos data-* impresos por Liquid a partir de la ficha REAL del producto: este script no inventa nada.
   - En la tienda publicada (data-live="true") los campos vacios se ocultan.
   - En la vista previa y el editor se muestra un marcador "Dato por completar" para saber que campo llenar. */
(function () {
  'use strict';
  var dlg = document.querySelector('[data-isheet]');
  if (!dlg) return;
  var $ = function (s) { return dlg.querySelector(s); };
  var el = {
    count: $('[data-is-count]'), name: $('[data-is-name]'), amountRow: $('[data-is-amount-row]'), amount: $('[data-is-amount]'), unit: $('[data-is-unit]'),
    fnRow: $('[data-is-fn-row]'), fn: $('[data-is-fn]'), descRow: $('[data-is-desc-row]'), desc: $('[data-is-desc]'),
    prev: $('[data-is-prev]'), next: $('[data-is-next]'), prevName: $('[data-is-prev-name]'), nextName: $('[data-is-next-name]'), body: $('[data-is-body]')
  };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var list = [], idx = 0, opener = null, hideTimer;

  function groupOf(trigger) {
    var g = trigger.getAttribute('data-ing-group');
    var seen = {}, out = [];
    document.querySelectorAll('[data-ing-open][data-ing-group="' + g + '"]').forEach(function (n) {
      var i = n.getAttribute('data-ing-index');
      if (seen[i]) return;
      seen[i] = 1; out.push(n);
    });
    out.sort(function (a, b) { return (+a.getAttribute('data-ing-index')) - (+b.getAttribute('data-ing-index')); });
    return out;
  }

  function setField(row, valueEl, value, live, placeholder) {
    var has = value && value.trim() !== '';
    if (has) { row.hidden = false; valueEl.textContent = value; valueEl.classList.remove('is-ph'); return; }
    if (live) { row.hidden = true; return; }
    row.hidden = false; valueEl.textContent = placeholder; valueEl.classList.add('is-ph');
  }

  function fill(i, animate) {
    idx = i;
    var t = list[i], d = t.dataset, live = d.live === 'true';
    function paint() {
      el.count.textContent = 'Ingrediente ' + String(i + 1).padStart(2, '0') + ' de ' + String(list.length).padStart(2, '0');
      el.name.textContent = d.name || 'Ingrediente';
      if (d.amount && d.amount.trim() !== '') {
        el.amountRow.hidden = false; el.amount.textContent = d.amount; el.unit.textContent = d.unit || ''; el.amount.classList.remove('is-ph');
      } else if (live) { el.amountRow.hidden = true; }
      else { el.amountRow.hidden = false; el.amount.textContent = '— —'; el.unit.textContent = ''; el.amount.classList.add('is-ph'); }
      setField(el.fnRow, el.fn, d.function, live, 'Función por completar');
      setField(el.descRow, el.desc, d.desc, live, 'Descripción por completar');
      var p = list[(i - 1 + list.length) % list.length], n = list[(i + 1) % list.length];
      el.prevName.textContent = p.dataset.name; el.nextName.textContent = n.dataset.name;
      var single = list.length < 2; el.prev.hidden = single; el.next.hidden = single;
    }
    if (animate && !reduce.matches) {
      el.body.classList.add('is-swap');
      setTimeout(function () { paint(); el.body.classList.remove('is-swap'); }, 180);
    } else paint();
  }

  function open(trigger) {
    opener = trigger; list = groupOf(trigger);
    var i = list.findIndex(function (n) { return n.getAttribute('data-ing-index') === trigger.getAttribute('data-ing-index'); });
    clearTimeout(hideTimer);
    fill(Math.max(0, i), false);
    if (typeof dlg.showModal === 'function') { if (!dlg.open) dlg.showModal(); } else dlg.setAttribute('open', '');
    document.body.classList.add('v-lock');
    requestAnimationFrame(function () { requestAnimationFrame(function () { dlg.classList.add('is-open'); }); });
    $('[data-is-close]').focus({ preventScroll: true });
  }
  function close() {
    dlg.classList.remove('is-open');
    document.body.classList.remove('v-lock');
    hideTimer = setTimeout(function () { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); }, reduce.matches ? 0 : 650);
    if (opener && document.contains(opener)) opener.focus({ preventScroll: true });
  }
  function step(d) { fill((idx + d + list.length) % list.length, true); }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-ing-open]');
    if (t) { e.preventDefault(); open(t); }
  });
  document.addEventListener('keydown', function (e) {
    var t = e.target.closest && e.target.closest('[data-ing-open]');
    if (t && t.getAttribute('role') === 'button' && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); open(t); }
  });
  dlg.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
  });
  dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });      // Esc
  dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });      // clic en el fondo
  $('[data-is-close]').addEventListener('click', close);
  el.prev.addEventListener('click', function () { step(-1); });
  el.next.addEventListener('click', function () { step(1); });

  // Gesto tactil: deslizar a los lados cambia de ingrediente
  var sx = null;
  dlg.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
  dlg.addEventListener('touchend', function (e) {
    if (sx == null) return; var dx = e.changedTouches[0].clientX - sx; sx = null;
    if (Math.abs(dx) > 70) step(dx < 0 ? 1 : -1);
  });
})();
